import type { Avatar } from "@coup/shared";

// Dev only: ?as=<n> keeps the seat token per tab so one browser can hold several seats.
const perTab = import.meta.env.DEV && new URLSearchParams(location.search).has("as");
const tokens = () => (perTab ? sessionStorage : localStorage);

export const getToken = (code: string) => tokens().getItem(`coup:${code}`) ?? undefined;
export const setToken = (code: string, token: string) => tokens().setItem(`coup:${code}`, token);
export const clearToken = (code: string) => tokens().removeItem(`coup:${code}`);

type PresetAvatar = Extract<Avatar, { kind: "preset" }>;

export interface SavedProfile {
  name: string;
  avatar: PresetAvatar;
}

/** Last-used name and preset avatar. Uploaded images are never saved. */
export function loadProfile(): SavedProfile | null {
  try {
    return JSON.parse(localStorage.getItem("coup:profile") ?? "null");
  } catch {
    return null;
  }
}

export function saveProfile(name: string, avatar: Avatar) {
  const preset = avatar.kind === "preset" ? avatar : loadProfile()?.avatar;
  if (preset) localStorage.setItem("coup:profile", JSON.stringify({ name, avatar: preset }));
}
